import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { MainContext } from '../../context/MainContext';
import { useContext, useEffect } from 'react';
import Spinner from '../../components/Spinner';
import { useDispatch, useSelector } from 'react-redux';
import Header from './components/Header';
import Breadcrumbs from './components/Breadcrumbs';
import { getProjects } from '../../services/redux/projects/actions';
import Footer from './components/Footer';
import styles from './index.module.scss';
import ErrorPage from '../../modules/quality/ocr/Utils/ErrorPage';
import { Layout as AntdLayout } from 'antd';
import { useState } from 'react';
import Sider from './components/Sider';
import { getUserMe } from '../../services/redux/users/actions';
import { jwtDecode } from 'jwt-decode';
import { getLogout } from '../../services/redux/auth/actions';

const { wrapper } = styles;
const { Content } = AntdLayout;

const Layout = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { loading, setLoading, error, setError, showUploadDelayInfo } =
    useContext(MainContext);
  const { isLoggedIn, me } = useSelector(({ auth }) => auth);
  const [isSiderOpen, setIsSiderOpen] = useState(false);

  useEffect(() => {
    setLoading(false);
    setError(undefined);
  }, [location, setLoading, setError]);

  useEffect(() => {
    let user;
    if (!me) {
      user = localStorage.getItem('token')
        ? jwtDecode(localStorage.getItem('token'))
        : undefined;
      if (user) {
        dispatch(getUserMe(user.id));
      } else {
        dispatch(getLogout());
      }
    }
  }, [dispatch, me]);

  useEffect(() => {
    if (isLoggedIn) {
      dispatch(getProjects());
    }
  }, [dispatch, isLoggedIn]);

  useEffect(() => {
    function injectToken(token) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'jwt_token';
      input.id = 'jwt_token';
      input.value = token;
      document.getElementById('root').appendChild(input);
    }
    if (isLoggedIn) {
      injectToken(localStorage.getItem('token'));
    }
  }, [isLoggedIn]);

  if (error) {
    return <ErrorPage errorMessages={error} />;
  }

  if (!isLoggedIn) {
    return <Navigate to="/login" />;
  }
  return (
    <AntdLayout style={{ minHeight: '100%' }}>
      {loading && (
        <Spinner loading={loading} showUploadDelayInfo={showUploadDelayInfo} />
      )}
      <div className={wrapper}>
        <Header />

        <AntdLayout>
          {!location.pathname.includes('projects') && (
            <Sider
              collapsed={!isSiderOpen}
              onCollapse={(value) => setIsSiderOpen(value)}
            />
          )}
          <AntdLayout>
            <Breadcrumbs
              onToggleMenu={() => {
                setIsSiderOpen((prev) => !prev);
              }}
            />
            <Content>
              <main style={{ position: 'relative' }}>
                <div className="container">{me && <Outlet />}</div>
              </main>
            </Content>
          </AntdLayout>
        </AntdLayout>
        <Footer />
      </div>
    </AntdLayout>
  );
};

export default Layout;
